export default function keycloakReducer(keycloak = {}, action) {
  return keycloak;
}
